import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { PagedTableModel } from '@src/shared/tables/paged-table-model';
import { InventoriesService } from '@src/services/inventories/inventories.service';
import { ConfigService } from '@src/services/layout/config.service';
import { NgxDatatableBase } from '@src/shared/tables/ngx-datatable-base';
import { TranslateService } from '@ngx-translate/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Inventory } from '@src/model/inventory';
import { Subject } from 'rxjs';
import { WindowEventsDispatcher } from '@src/core/WindowEventsDispatcher';
import { UserRolesEnum } from '@src/model/userRoles';
import { IAuthService } from '@src/auth/auth.service.interface';
import { FileUploader } from 'ng2-file-upload';
import { environment } from '@src/environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { ImportedFile } from '@src/model/importedFile';
import { ImportedFileHelper } from '@src/base-components/management/utils/imported-file-helper';
import { UploadType } from '@src/model/Enums/uploadType';
import { ToastrService } from 'ngx-toastr';
import { FileValidationError } from '@src/model/fileValidationError';
import { fileValidationErrorType } from '@src/model/Enums/fileValidationErrorType';
import { InventoriesParameters } from '@src/model/filter-parameters/inventories-parameters';
import { InventoriesFilterComponent } from './filter/inventories-filter.component';

@Component({
    selector: 'app-inventories',
    templateUrl: './inventories.component.html',
    styleUrls: ['./inventories.component.scss'],
})
export class InventoriesComponent extends NgxDatatableBase implements OnInit {
    model = new PagedTableModel();
    showRetailer = false;
    selected: Inventory[] = [];
    firstLoad = false;
    isLoading = false;
    offset = 0;
    queryTermChanged: Subject<string> = new Subject<string>();
    layoutDirection: string;
    pagerLeftArrowIcon: string;
    pagerRightArrowIcon: string;
    pagerPreviousIcon: string;
    pagerNextIcon: string;
    uploaderStocks: FileUploader;
    datasource: ImportedFile[] = [];
    filterParameters: InventoriesParameters;
    newfilterParameters: InventoriesParameters;
    previousUrl: string;
    currentUrl:string;
    hasNewFilter:undefined;
    @ViewChild(DatatableComponent) table: DatatableComponent;
    @ViewChild(InventoriesFilterComponent) inventoriesFilterComponent: InventoriesFilterComponent;
    constructor(@Inject('AuthService')
        private authService: IAuthService,
        private inventoriesService: InventoriesService,
        private router: Router,
        private configService: ConfigService,
        protected oAuthservice: OAuthService,
        protected toastrService: ToastrService,
        private translateService: TranslateService) {
        super(translateService);
        this.showRetailer = this.showRetailerCol();
        this.setTableIconsByOrientation();
        this.model.sortOrder = 'inventoryCreationDate desc';
        this.currentUrl = this.router.url;
        router.events
            .subscribe((event) => {
                if (event instanceof NavigationEnd) {
                    this.previousUrl = this.router.url;
                    var str = this.currentUrl.split("/");
                    var str2 = this.previousUrl.split("/");
                    if(str[1] === str2[1])
                    {
                        // same route
                        let filters = localStorage.getItem('inventoriesFilters');
                        let inventoriesFilters = JSON.parse(filters);
                        if(inventoriesFilters !== null)
                        {
                            this.newfilterParameters = new InventoriesParameters();
                            this.newfilterParameters = inventoriesFilters;
                        }
                    }
                    else{
                        // diferent route
                        localStorage.removeItem('inventoriesFilters');
                    }
                }
            });

    }

    ngOnInit(): void {
        this.inventoriesFilterComponent.selectedTimeRange = 'last-month';
        const intervalDates = this.inventoriesFilterComponent.computeTimeRange('last-month');
        this.filterParameters = new InventoriesParameters();
        this.filterParameters.selectedTimeRange = 'last-month';
        this.filterParameters.from = intervalDates.from;
        this.filterParameters.to = intervalDates.to;
        if(this.newfilterParameters !== undefined){
            this.filterParameters = this.newfilterParameters;
        }
        this.queryTermChanged
            .debounceTime(1000) // wait 1000ms after the last event before emitting last event
            .distinctUntilChanged() // only emit if value is different from previous value
            .subscribe(v => {
                this.model.queryTerm = v;
                this.getInventories(1);
            });
        //this.getInventories(1);
        this.uploaderStocks = new FileUploader({
            removeAfterUpload: true,
            autoUpload: true,
            url: environment.apiBaseUrl + '/api/importeddata/inventories'
        });
        this.uploaderStocks.onBeforeUploadItem = () => {
            this.uploaderStocks.authToken = 'Bearer ' + this.oAuthservice.getAccessToken();
        };
        this.uploaderStocks.onCompleteItem = (item, response) => {
            // this.uploaderRetailersInput.nativeElement.value = '';
            if (item.isSuccess) {
                const result = JSON.parse(response);
                if (result.isSuccess) {
                    const newImportedFile = Object.assign(new ImportedFile, result.value);
                    newImportedFile.type = 'i';
                    newImportedFile.uploadStatusStr = ImportedFileHelper.computeFileStatus(newImportedFile.uploadStatus);
                    newImportedFile.uploadTypeStr = UploadType[newImportedFile.uploadType];

                    this.datasource.unshift(newImportedFile);
                    this.getInventories(1);
                } else {
                    this.showError(result.messageData);
                }
            } else {
                this.toastrService.error('Upload error');
            }
        };
    }

    ngOnDestroy(): void {
        const inventoriesFilters = JSON.stringify({
            store: this.filterParameters.store,
            from: this.filterParameters.from,            
            to: this.filterParameters.to,
            city: this.filterParameters.city,
            serialNumber: this.filterParameters.serialNumber,
            last : this.filterParameters.last,
            selectedTimeRange: this.filterParameters.selectedTimeRange
        });
        localStorage.setItem('inventoriesFilters', inventoriesFilters)
    }

    private showRetailerCol() {
        return this.authService.getCurrentUserInstant().isInRoles([UserRolesEnum.ADMIN, UserRolesEnum.AGENT, UserRolesEnum.MASTER_RETAILER, UserRolesEnum.MARKET_ADMIN]);
    }

    getInventories(page: number) {
        if (this.model.isLoading) {
            return;
        }
        if (page < 1) {
            page = 1;
        }
        this.model.isLoading = true;
        this
            .inventoriesService
            .queryInventories(this.model.queryTerm, this.model.sortOrder, this.model.pageSize, page)
            .subscribe(data => {
                this.model.rows = data.body.value;
                this.model.totalElements = data.headers.get('pageCount');
                this.model.pageNumber = page;
                this.model.offset = page - 1;
                if (this.firstLoad) {
                    // When the page changes and the lst page has little items, the width is incorrectly displayed (scrollbar problems)
                    // Force table size recalculation and re-render.
                    // this.table.recalculate();
                    WindowEventsDispatcher.fireDelayedResizeEvent(0);
                }
                this.firstLoad = true;
                this.model.isLoading = false;
            });
    }

    onSort(event) {
        if (this.model.isLoading) {
            return;
        }
        this.model.sortOrder = `${event.column.prop} ${event.newValue}`;
        this.filterInventories(1);
    }

    setPage(pageInfo) {
        this.getInventories(pageInfo.page);
    }

    onSearch(event: any) {
        this.queryTermChanged.next(event.target.value.trim());
    }

    goToInventoryDetails(): void {
        this.router.navigateByUrl(`inventories/${this.selected[0].id}`);
    }

    setTableIconsByOrientation() {
        this.layoutDirection = this.configService.templateConf.layout.dir;
        this.pagerLeftArrowIcon = this.layoutDirection === 'rtl' ? 'datatable-icon-right' : 'datatable-icon-left';
        this.pagerRightArrowIcon = this.layoutDirection === 'rtl' ? 'datatable-icon-left' : 'datatable-icon-right';
        this.pagerPreviousIcon = this.layoutDirection === 'rtl' ? 'datatable-icon-skip' : 'datatable-icon-prev';
        this.pagerNextIcon = this.layoutDirection === 'rtl' ? 'datatable-icon-prev' : 'datatable-icon-skip';
    }
    translateError(error: FileValidationError): string {
        switch (error.ErrorType) {
            case fileValidationErrorType.invalidHeaders: {
                return this.translateService.instant('Components.Management.ValidationsErrors.invalid-headers');
            }
            case fileValidationErrorType.invalidValue: {
                return this.translateService.instant('Components.Management.ValidationsErrors.invalid-value', { columnName: error.ColumnName, line: error.Line });
            }
            case fileValidationErrorType.missingRequiredValue: {
                return this.translateService.instant('Components.Management.ValidationsErrors.required-value', { columnName: error.ColumnName, line: error.Line });
            }
            case fileValidationErrorType.outOfSafeLimitOfRows: {
                return this.translateService.instant('Components.Management.ValidationsErrors.out-of-limit-rows');
            }
            default: {
                return this.translateService.instant('Components.Management.ValidationsErrors.unkown-error');
            }
        }
    }
    showError(messageData: string): void {
        var error = JSON.parse(messageData) as FileValidationError;
        this.toastrService.error(this.translateError(error), "", { timeOut: 10000 });
    }
    
    updateInventories(event) {
        this.filterParameters = event;
        this.filterInventories(1);
    }

    protected filterInventories(page: number) {
        if (this.model.isLoading) {
            return;
        }
        if (page < 1) {
            page = 1;
        }
        this.model.isLoading = true;
        this
            .inventoriesService
            .filterInventories(this.filterParameters, this.model.sortOrder, this.model.pageSize, page)
            .subscribe(data => {
                this.model.rows = data.body.value;
                this.model.totalElements = data.headers.get('pageCount');
                this.model.pageNumber = page;
                this.model.offset = page - 1;
                if (this.firstLoad) {
                    // When the page changes and the lst page has little items, the width is incorrectly displayed (scrollbar problems)
                    // Force table size recalculation and re-render.
                    // this.table.recalculate();
                    WindowEventsDispatcher.fireDelayedResizeEvent(0);
                }
                this.firstLoad = true;
                this.model.isLoading = false;
            });
    }
}
